import { getPlatform, inject, Injectable } from '@angular/core';
import { ProjectService, WmHttpService } from "@wms/app/services";
import { BaseComponent } from "@wms/components";
import { environment } from "@wms/app";

@Injectable({
  providedIn: 'root'
})
export class PageTemplatesService extends BaseComponent{

  templateList: any

  private TARGET: string = "PageTemplates";
  private API_META: any = {
    upload: {
      url: environment.SERVICES_BASE_PATH + "services/import",
      method: "POST",
      params: {
        "packageType": 'TEMPLATEBUNDLE'
      }
    },
    listTemplates: {
      url: environment.SERVICES_BASE_PATH + "services/templatebundles?platformType=:platformType&template=:template",
      method: "GET",

    },
    listCategories: {
      url: environment.SERVICES_BASE_PATH + "services/templatebundles/categories?platformType=:platformType&template=:template",
      method: "GET",
    },
    listBundles: {
      url: environment.SERVICES_BASE_PATH + "services/templatebundles/bundles",
      method: "GET"
    },
    remove: {
      url: environment.SERVICES_BASE_PATH + "services/templatebundles/:templateBundleId/versions/:versionId",
      method: "DELETE"
    },
    export: {
      url: environment.SERVICES_BASE_PATH + "services/projects/:projectID/export",
      method: "POST"
    },
    import: {
      url: environment.SERVICES_BASE_PATH + "services/import",
      method: "POST",
      params: {
          "packageType": 'TEMPLATEBUNDLE'
      }
    },
    importDT: {
      url: environment.SERVICES_BASE_PATH +
        "services/projects/:projectID/design-tokens/import",
      method: "POST"
    }
  }


  constructor(private wmHttpService: WmHttpService) {
    super()
    this.wmHttpService.registerApiMeta(this.TARGET, this.API_META);
  }


  upload(uploadConfig: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: "import",
      data: uploadConfig.content,
      toasterInfo : {
        'success': { title: this.locale.MESSAGE_SUCCESS_TITLE, 'description': this.locale.MESSAGE_SUCCESS_IMPORT },
      },
      spinnerInfo: {
        showSpinner: false
      }
    }) as Promise<any>);
  }

  getCategories(): Promise<any> {
    const projectDetails = this.projectService.getDetails();
    return (this.wmHttpService.execute({
      target: "PageTemplates",
      action: "listCategories",
      urlParams: {
        platformType: projectDetails.platformType.toUpperCase(),
        template: projectDetails.template || 'DEFAULT'
      }
    }) as Promise<any>);
  }

  list(isWidgetTemplate: any, templatePlatFormType: string): Promise<any> {
    let projectDetails = this.projectService.getDetails();
    if (this.templateList && isWidgetTemplate) {
      return Promise.resolve(this.templateList)
    }
    let urlConfig = {
      target: "PageTemplates",
      action: "listTemplates",
      urlParams: {
        platformType: projectDetails.platformType === 'NATIVE_MOBILE'? 'MOBILE' :  projectDetails.platformType.toUpperCase(),
        template: projectDetails.template || 'DEFAULT'
      }
    }
    if (projectDetails.type === 'PREFAB') {
      urlConfig.urlParams.platformType = templatePlatFormType;
    }
    return (this.wmHttpService.execute(urlConfig) as Promise<any>).then((response: any) => {
      this.templateList = response;
      return response;
    })
  }

  getTemplateBundles() {
    return (this.wmHttpService.execute({
      target: "PageTemplates",
      action: "listBundles"
    }) as Promise<any>);
  }

  getPlatformType() {
    return this.projectService.getDetails().platformType.toUpperCase()
  }

  removeTemplateBundle(params: any) {
    return (this.wmHttpService.execute({
      target: "PageTemplates",
      action: "remove",
      pathParams: {
        templateBundleId: params.templateBundleID,
        versionId: params.versionId
      }
    }) as Promise<any>);
  }

  export(params: any): Promise<any> {
    return (this.wmHttpService.execute({
      target: this.TARGET,
      action: 'export',
      data: {
        "exportType": params.exportType,
        "targetName": params.targetName
      },
      urlParams: {
        projectID: params.projectId
      }
    }) as Promise<any>);
  }

    importDesignTokens(params: any): Promise<any> {
      const formData = new FormData();
      formData.append('file', params.zipFile.file, params.zipFile.name); 
  
      return this.wmHttpService.execute({
        target: this.TARGET,
        action: "importDT",
        data: formData,
        urlParams: {
          projectID: params.projectId
        },
        spinnerInfo: {
          showSpinner: true
        },
        toasterInfo: {
          success: {
            title: "Success",
            description: "Design tokens imported successfully"
          }
        }
      }) as Promise<any>;
    }
}